import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';

const ModalModifyCallEat = ({ isVisible, onClose, choosenCallEat }) => {

    let token = localStorage.getItem("token");
    const [values, setValues] = useState({
        id_client: '',
        nom_client: '',
        room_id: '',
        autorised: ''
    })


    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }

    // console.log(choosenCallEat);
    if (choosenCallEat.id_client !== values.id_client) setValues({ ...values, ...choosenCallEat })



    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    const deleteClient = (e) => {
        e.preventDefault();
        let data = {
            id_client: values.id_client
        }
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_call_eat`,{headers, data})
        .then((res) => {
                console.log(res);
                // navigate('/listusers');
                window.location.reload(false);
            }).catch(err => console.log(err))

    }
    const handleSubmit = (e) => {
        e.preventDefault();
        let error = document.getElementById('error');
        error.innerHTML = '';
        if (values.nom_client === '' || values.room_id === '' || values.autorised === '') {
            error.innerHTML = "Veuillez renseigner tout les champs"
        } else {
            // console.log(values);
            axios.put(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/update_call_eat`, values)
            .then(res => {
                // console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }


    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }

    if (!isVisible) return null;
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Modifier le client CallEat</h2>
                    <button className='text-slate-400 hover:text-slate-600 text-xl leading-none' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom_client" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom Client</label>
                        <input type="text" name="nom_client" id="nom_client" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom du client" required onChange={e => setValues({ ...values, nom_client: e.target.value })} value={values.nom_client} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="room_id" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Room ID</label>
                        <input type="text" name="room_id" id="room_id" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Room ID" required onChange={e => setValues({ ...values, room_id: e.target.value })} value={values.room_id} />
                    </div>
                    <div className="mb-4">
                        <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Autorisé</span>
                        <div className="flex items-center gap-6">
                            <label className="inline-flex items-center gap-2 text-sm text-slate-700 hover:cursor-pointer" htmlFor="inlineCheckbox1">
                                <input
                                    className="h-4 w-4 accent-indigo-500 hover:cursor-pointer"
                                    type="radio"
                                    id="inlineCheckbox1"
                                    value={1}
                                    onChange={e => setValues({ ...values, autorised: e.target.value })}
                                    defaultChecked={values.autorised === 1 ? true : false}
                                    name="autorised"
                                />
                                Oui
                            </label>
                            <label className="inline-flex items-center gap-2 text-sm text-slate-700 hover:cursor-pointer" htmlFor="inlineCheckbox2">
                                <input
                                    className="h-4 w-4 accent-indigo-500 hover:cursor-pointer"
                                    type="radio"
                                    id="inlineCheckbox2"
                                    value={0}
                                    onChange={e => setValues({ ...values, autorised: e.target.value })}
                                    defaultChecked={values.autorised === 0 ? true : false}
                                    name="autorised" />
                                Non
                            </label>
                        </div>
                    </div>

                    <div className='flex justify-between gap-3'>
                        <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                        <Popup trigger=
                            {<button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                            position="right center">
                            <div>Est-ce votre dernier mot?</div>
                            <div className="flex justify-between gap-2">
                                <button type="button" className="rounded-lg bg-indigo-500 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-600" onClick={deleteClient}> Accepter </button>
                                <button type="button" className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                    </div>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalModifyCallEat;